'use client';

import { useState, useEffect } from 'react';
import { cn } from '@/shared/utils/tw';
import type { Toast } from '../types/toast-types';

interface ToastTTSProps {
  toast: Toast;
}

/**
 * Toast-TTS: AI 응답 자막 토스트 (Figma: 3152:2802)
 */
export const ToastTTS = ({ toast }: ToastTTSProps) => {
  const [displayedText, setDisplayedText] = useState('');

  // 타이핑 효과 (글자 단위 스트리밍)
  useEffect(() => {
    if (toast.message.length < displayedText.length) {
      setDisplayedText('');
    }
    if (toast.message.length > displayedText.length) {
      const timer = setTimeout(() => {
        setDisplayedText(toast.message.slice(0, displayedText.length + 1));
      }, 30);
      return () => clearTimeout(timer);
    }
  }, [toast.message, displayedText]);

  return (
    <div
      className={cn(
        'rounded-[16px]',
        'px-[18px] py-[10px]',
        'font-pretendard text-[15px] font-medium text-black text-center leading-[1.4] break-keep',
        'pointer-events-auto',
        'max-w-[85cqw]',
        toast.isExiting ? 'animate-toast-exit' : 'animate-toast-enter'
      )}
      style={{
        background: 'rgba(255, 255, 255, 0.5)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: '1.5px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      {displayedText}
      {displayedText.length < toast.message.length && (
        <span className="inline-block w-1 h-4 ml-0.5 bg-black/40 animate-pulse" />
      )}
    </div>
  );
};
